module.exports = __webpack_public_path__ + "images/marketing/peeps/christy_kondo.jpg";